enum StockType {
  ITEM_TYPE_UNKNOWN = "ITEM_TYPE_UNKNOWN",
  TEXT = "TEXT",
  URL = "URL",
  QR = "QRCODE",
  PDF = "PDF",
  FILE = "FILE"
}

export default StockType
